import api from './axios';

const BASE = '/notes';

// ---------------------------------------------------------------------------
// Style Template
// ---------------------------------------------------------------------------

export const getStyleTemplate = () =>
  api.get(`${BASE}/style-template/`);

export const saveStyleTemplate = (data) =>
  api.post(`${BASE}/style-template/`, data);

export const updateStyleTemplate = (templateId, data) =>
  api.patch(`${BASE}/style-template/${templateId}/`, data);

export const deleteStyleTemplate = (templateId) =>
  api.delete(`${BASE}/style-template/${templateId}/`);

// ---------------------------------------------------------------------------
// Appointments
// ---------------------------------------------------------------------------

export const listAppointments = (patientId) =>
  api.get(`${BASE}/patients/${patientId}/appointments/`);

export const createAppointment = (patientId, data) =>
  api.post(`${BASE}/patients/${patientId}/appointments/`, data);

// ---------------------------------------------------------------------------
// Notes (patient-level)
// ---------------------------------------------------------------------------

export const listNotes = (patientId) =>
  api.get(`${BASE}/patients/${patientId}/notes/`);

export const getMissingNotes = (patientId) =>
  api.get(`${BASE}/patients/${patientId}/missing-notes/`);

export const generateAllMissingNotes = (patientId, data = {}) =>
  api.post(`${BASE}/patients/${patientId}/generate-missing-notes/`, data);

// ---------------------------------------------------------------------------
// Notes (appointment-level)
// ---------------------------------------------------------------------------

/**
 * Create a draft note for an appointment.
 *   - data.text provided  → manual draft (generated_by="user")
 *   - data.text omitted   → AI-generated draft (generated_by="system")
 * Optional: data.claim_id, data.quick_facts (for AI path)
 */
export const submitNoteForAppointment = (appointmentId, data = {}) =>
  api.post(`${BASE}/appointments/${appointmentId}/note/`, data);

// ---------------------------------------------------------------------------
// Note actions
// ---------------------------------------------------------------------------

export const getNote = (noteId) =>
  api.get(`${BASE}/notes/${noteId}/`);

export const updateNote = (noteId, data) =>
  api.patch(`${BASE}/notes/${noteId}/`, data);

export const approveNote = (noteId, data = {}) =>
  api.post(`${BASE}/notes/${noteId}/approve/`, data);

export const deleteNote = (noteId) =>
  api.delete(`${BASE}/notes/${noteId}/`);

export const regenerateNote = (noteId, data = {}) =>
  api.post(`${BASE}/notes/${noteId}/regenerate/`, data);

export const attachNoteToClaim = (noteId, claimId) =>
  api.post(`${BASE}/notes/${noteId}/attach-claim/`, { claim_id: claimId });

export const detachNoteFromClaim = (noteId) =>
  api.post(`${BASE}/notes/${noteId}/detach-claim/`, {});
